import React, { useState, useContext } from 'react';
import Check from 'wix-ui-icons-common/Check';
import { useSelector } from 'react-redux';
import { selectSiteTokenDetails } from '../../../common/redux/features/playground/selectors';
import { openTokenModalClick } from '../../LoggerFactory/BiAnalyticsLogger/events';
import { LOGGER_TYPES } from '../../LoggerFactory/loggerTypes';
import { LazyLoader } from '../LazyLoader';
import { LoggerContext } from '../../appContext/LoggerProvider';
import { Text } from '../PageElements/Text';
import style from './TokenBar.scss';
import { isTokenEmpty } from './utils';
import { Button } from '../Layout/Button';
import { isClientSide } from '../../../common/utils';

const TokenModal = React.lazy(() => import('./TokenModal'));

export const TokenBar = () => {
  const { logger } = useContext(LoggerContext);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const selectedSiteTokenDetails = useSelector(selectSiteTokenDetails);

  return (
    <div data-hook="token-bar" className={style.tokenBar}>
      {isClientSide() && isModalOpen && (
        <LazyLoader
          lazyComponent={TokenModal}
          setIsModalOpen={setIsModalOpen}
          defaultViewPosition={getDefaultViewPosition()}
        />
      )}
      {!isTokenEmpty(selectedSiteTokenDetails.token) && (
        <Check data-hook="check-mark" className={style.check} />
      )}
      <Text dataHook="token-bar-text" size="small" tagName="span">
        {isTokenEmpty(selectedSiteTokenDetails.token)
          ? 'Generate a test token to explore our APIs'
          : `Test token available for ${selectedSiteTokenDetails.name}`}
      </Text>
      <Button
        data-hook="open-manage-token-modal-btn"
        onClick={onGetTestTokenClick}
        className={style.btn}
        skin="secondary"
        size="tiny"
      >
        {isTokenEmpty(selectedSiteTokenDetails.token)
          ? 'Get Test Token'
          : 'View Token'}
      </Button>
    </div>
  );

  function getDefaultViewPosition() {
    return isTokenEmpty(selectedSiteTokenDetails.token) ? 0 : 1;
  }

  function onGetTestTokenClick() {
    setIsModalOpen(true);
    logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(openTokenModalClick, {
      isTokenExist: !isTokenEmpty(selectedSiteTokenDetails.token),
      origin: 'main_header',
    });
  }
};
